module.exports = __webpack_public_path__ + "static/media/vector-check-white.680ffe7b.svg";